export default {
  always: 'ALWAYS',
  enabled: 'ENABLED',
  disabled: 'DISABLED',
  required: 'REQUIRED',
};
